import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AuthGuard } from '../../guards/authguard/auth-guard';
import { SalesGuard } from '../../guards/salesguard/sales-guard.guard';
import { SharedModule } from '../../shared/shared.module';
import { SalespersonDashboardComponent } from './components/salesperson-dashboard/salesperson-dashboard.component';

const routes: Routes = [
  {
    path: '',
    component: SalespersonDashboardComponent,
    canActivate: [AuthGuard, SalesGuard]
  }
];

@NgModule({
  declarations: [SalespersonDashboardComponent],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    TranslateModule.forChild({ extend: true }),
    RouterModule.forChild(routes)
  ]
})
export class SalespersonDashboardModule {}
